import { render, staticRenderFns } from "./AdminSupportDetailsView.vue?vue&type=template&id=dbdeaafc&scoped=true&"
import script from "./AdminSupportDetailsView.vue?vue&type=script&lang=js&"
export * from "./AdminSupportDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./AdminSupportDetailsView.vue?vue&type=style&index=0&id=dbdeaafc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbdeaafc",
  null
  
)

export default component.exports